<div class="row page-header">
    <div class="col-12">
        <h1>Consumable Quantities <small>Track quantities of consumable materials by location</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        [padding]="73"
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Consumable'"
                            [binding]="'material'"
                            [dataMap]="materialMap"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Location'"
                            [binding]="'location'"
                            [dataMap]="locationMap"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Quantity'" [binding]="'quantity'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Price Each'"
                            [binding]="'price'"
                            [format]="'C2'"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Total Price'"
                            [binding]="'totalPrice'"
                            [format]="'C2'"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
                </div>
            </div>
        </div>
    </div>
</div>
